// packages/ag-charts-locale/src/sk-SK.ts
var AG_CHARTS_LOCALE_SK_SK = {
  ariaAnnounceChart: "graf, ${seriesCount}[number] s\xE9ri\xED",
  ariaAnnounceFlowProportionLink: "odkaz ${index} z ${count}, od ${from} do ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "uzol ${index} z ${count}, ${description}",
  ariaAnnounceGaugeChart: "stupnicov\xFD graf, ${caption}",
  ariaAnnounceHierarchyChart: "hierarchick\xFD graf, ${caption}",
  ariaAnnounceHierarchyDatum: "\xFArove\u0148 ${level}[number], ${count}[number] det\xED, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Stla\u010Den\xEDm medzern\xEDka alebo kl\xE1vesy Enter prepnete vidite\u013Enos\u0165",
  ariaLabelAddHorizontalLine: "Prida\u0165 vodorovn\xFA \u010Diaru",
  ariaLabelAnnotationOptionsToolbar: "Mo\u017Enosti anot\xE1cie",
  ariaLabelAnnotationSettingsDialog: "Nastavenia anot\xE1ci\xED",
  ariaLabelColorPicker: "V\xFDber farby",
  ariaLabelFinancialCharts: "Finan\u010Dn\xE9 grafy",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, Polo\u017Eka legendy ${index}[number] z ${count}[number]",
  ariaLabelLegendItemUnknown: "Nezn\xE1ma polo\u017Eka legendy",
  ariaLabelLegendPageNext: "\u010Eal\u0161ia strana legendy",
  ariaLabelLegendPagePrevious: "Predch\xE1dzaj\xFAca str\xE1nka legendy",
  ariaLabelLegendPagination: "Str\xE1nkovanie legendy",
  ariaLabelNavigator: "Navig\xE1tor",
  ariaLabelNavigatorMaximum: "Maximum",
  ariaLabelNavigatorMinimum: "Minim\xE1lne",
  ariaLabelNavigatorRange: "Rozsah",
  ariaLabelRangesToolbar: "Rozsahy",
  ariaLabelSettingsTabBar: "Nastavenia",
  ariaLabelZoomToolbar: "Pribl\xED\u017Ei\u0165",
  ariaValuePanRange: "${min}[percent0to2dp] do ${max}[percent0to2dp]",
  contextMenuDownload: "Stiahnu\u0165",
  contextMenuPanToCursor: "Posun\xFA\u0165 sem",
  contextMenuToggleOtherSeries: "Prepn\xFA\u0165 in\xE9 s\xE9rie",
  contextMenuToggleSeriesVisibility: "Prepn\xFA\u0165 vidite\u013Enos\u0165",
  contextMenuZoomToCursor: "Pribl\xED\u017Ei\u0165 sem",
  dialogHeaderChannel: "Kan\xE1l",
  dialogHeaderDatePriceRange: "D\xE1tum a cena",
  dialogHeaderDateRange: "Rozsah d\xE1tumov",
  dialogHeaderFibonacciRange: "Fib Oprava",
  dialogHeaderLine: "\u010Ciara",
  dialogHeaderPriceRange: "Cenov\xE9 rozp\xE4tie",
  dialogHeaderText: "Text",
  dialogInputAlign: "Zarovna\u0165",
  dialogInputColorPicker: "Farba",
  dialogInputColorPickerAltText: "Farba textu",
  dialogInputExtendAbove: "Roz\u0161\xEDri\u0165 nad",
  dialogInputExtendBelow: "Roz\u0161\xEDri\u0165 nadol",
  dialogInputExtendChannelEnd: "Roz\u0161\xEDri\u0165 koniec kan\xE1la",
  dialogInputExtendChannelStart: "Pred\u013A\u017Ei\u0165 za\u010Diatok kan\xE1la",
  dialogInputExtendLeft: "Roz\u0161\xEDri\u0165 do\u013Eava",
  dialogInputExtendLineEnd: "Pred\u013A\u017Ei\u0165 koniec \u010Diary",
  dialogInputExtendLineStart: "Pred\u013A\u017Ei\u0165 za\u010Diatok \u010Diary",
  dialogInputExtendRight: "Roz\u0161\xEDri\u0165 doprava",
  dialogInputFibonacciBands: "P\xE1sma",
  dialogInputFibonacciBandsAltText: "Fibonacciho p\xE1sma",
  dialogInputFillColorPicker: "Vyplni\u0165",
  dialogInputFillColorPickerAltText: "Farba v\xFDplne",
  dialogInputFontSize: "Ve\u013Ekos\u0165",
  dialogInputFontSizeAltText: "Ve\u013Ekos\u0165 p\xEDsma",
  dialogInputLineStyle: "\u010Ciarkovan\xFD",
  dialogInputPosition: "Poz\xEDcia",
  dialogInputReverse: "Opa\u010Dne",
  dialogInputShowFill: "Zobrazi\u0165 v\xFDpl\u0148",
  dialogInputStrokeWidth: "Hr\xFAbka \u010Diary",
  dialogInputStrokeWidthAltText: "Hr\xFAbka l\xEDnie",
  iconAltTextAlignCenter: "Centrova\u0165",
  iconAltTextAlignLeft: "V\u013Eavo",
  iconAltTextAlignRight: "Vpravo",
  iconAltTextClose: "Zavrie\u0165",
  iconAltTextLineStyleDashed: "Dlh\xE9 poml\u010Dky",
  iconAltTextLineStyleDotted: "Kr\xE1tka poml\u010Dka",
  iconAltTextLineStyleSolid: "Pln\xE1",
  iconAltTextPositionBottom: "Dno",
  iconAltTextPositionCenter: "Stred",
  iconAltTextPositionTop: "Horn\xE1",
  inputTextareaPlaceholder: "Prida\u0165 text",
  measurerDateRangeBars: "${value}[number] pruhy",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Objem ${value}",
  overlayLoadingData: "Na\u010D\xEDtavam \xFAdaje...",
  overlayNoData: "\u017Diadne \xFAdaje na zobrazenie",
  overlayNoVisibleSeries: "\u017Diadna vidite\u013En\xE1 s\xE9ria",
  overlayUnsupportedBrowser: "Nezlu\u010Dite\u013En\xE1 verzia prehliada\u010Da. Pros\xEDm, aktualizujte si prehliada\u010D.",
  seriesHistogramTooltipCount: "${yName} (po\u010Det)",
  seriesHistogramTooltipFrequency: "Frekvencia",
  seriesHistogramTooltipMean: "${yName} (priemer)",
  seriesHistogramTooltipSum: "${yName} (s\xFA\u010Det)",
  toolbarAnnotationsArrow: "\u0160\xEDpka",
  toolbarAnnotationsArrowDown: "\u0160\xEDpka dole",
  toolbarAnnotationsArrowUp: "\u0160\xEDpka hore",
  toolbarAnnotationsCallout: "Popis",
  toolbarAnnotationsClearAll: "Vymaza\u0165 v\u0161etko",
  toolbarAnnotationsComment: "Koment\xE1r",
  toolbarAnnotationsDatePriceRange: "D\xE1tum a cena",
  toolbarAnnotationsDateRange: "\u010Casov\xE9 obdobie",
  toolbarAnnotationsDelete: "Vymaza\u0165",
  toolbarAnnotationsDisjointChannel: "Nez\xE1visl\xFD kan\xE1l",
  toolbarAnnotationsDragHandle: "\u0164aha\u0165 panel n\xE1strojov",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Retracement",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Based na z\xE1klade trendu",
  toolbarAnnotationsFillColor: "Farba v\xFDplne",
  toolbarAnnotationsHorizontalLine: "Horizont\xE1lna \u010Diara",
  toolbarAnnotationsLineAnnotations: "Trendov\xE9 \u010Diary",
  toolbarAnnotationsLineColor: "Farba \u010Diary",
  toolbarAnnotationsLineStrokeWidth: "\u0160\xEDrka \u010Diarov\xE9ho \u0165ahu",
  toolbarAnnotationsLineStyle: "\u0160t\xFDl \u010Diary",
  toolbarAnnotationsLock: "Zamkn\xFA\u0165",
  toolbarAnnotationsMeasurerAnnotations: "Merania",
  toolbarAnnotationsNote: "Pozn\xE1mka",
  toolbarAnnotationsParallelChannel: "Paraleln\xFD kan\xE1l",
  toolbarAnnotationsPriceRange: "Cenov\xFD rozsah",
  toolbarAnnotationsQuickDatePriceRange: "Zmera\u0165",
  toolbarAnnotationsSettings: "Nastavenia",
  toolbarAnnotationsShapeAnnotations: "\u0160\xEDpky",
  toolbarAnnotationsText: "Text",
  toolbarAnnotationsTextAnnotations: "Textov\xE9 anot\xE1cie",
  toolbarAnnotationsTextColor: "Farba textu",
  toolbarAnnotationsTextSize: "Ve\u013Ekos\u0165 textu",
  toolbarAnnotationsTrendLine: "Trendov\xE1 \u010Diara",
  toolbarAnnotationsUnlock: "Odomkn\xFA\u0165",
  toolbarAnnotationsVerticalLine: "Zvisl\xE1 \u010Diara",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 mesiac",
  toolbarRange1Year: "1R",
  toolbarRange1YearAria: "1 rok",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 mesiace",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 mesiacov",
  toolbarRangeAll: "V\u0161etky",
  toolbarRangeAllAria: "V\u0161etko",
  toolbarRangeYearToDate: "Od za\u010Diatku roka",
  toolbarRangeYearToDateAria: "Rok do dne\u0161n\xE9ho d\u0148a",
  toolbarSeriesTypeCandles: "Svie\u010Dky",
  toolbarSeriesTypeDropdown: "Typ grafu",
  toolbarSeriesTypeHighLow: "Vysok\xFD N\xEDzky",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Pr\xE1zdne svie\u010Dky",
  toolbarSeriesTypeLine: "\u010Ciara",
  toolbarSeriesTypeLineWithMarkers: "\u010Ciara so zna\u010Dkami",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Schodiskov\xFD graf",
  toolbarZoomPanEnd: "Posun\xFA\u0165 na koniec",
  toolbarZoomPanLeft: "Posun\xFA\u0165 do\u013Eava",
  toolbarZoomPanRight: "Posun\xFA\u0165 doprava",
  toolbarZoomPanStart: "Posun na za\u010Diatok",
  toolbarZoomReset: "Obnovi\u0165 pribl\xED\u017Eenie",
  toolbarZoomZoomIn: "Pribl\xED\u017Ei\u0165",
  toolbarZoomZoomOut: "Oddiali\u0165",
  tooltipPaginationStatus: "${index}[number] z ${count}[number]"
};
export {
  AG_CHARTS_LOCALE_SK_SK
};
//# sourceMappingURL=sk-SK.esm.mjs.map
